import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';
import { display } from '@mui/system';

const styles = makeStyles(() => ({
	main: {
		flexGrow: 1,
	},
	divClass: {
		margin: '30px',
	},
	buttonStyle: {
		width: '132px',
	},
	stackContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: useTheme().spacing(1),
		width: '95%',
	},
	stackClass: {
		width: '100%',
		justifyContent: 'flex-end',
	},
	addUserClass: {
		marginLeft: 4,
	},
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		gap: useTheme().spacing(1),
		marginLeft: useTheme().spacing(1),
	},
	rightButton: {
		marginLeft: useTheme().spacing(1),
	},
	fileInput: {
		display: 'none',
	},
	fileInputLabel: {
		display: 'flex',
		alignItems: 'center',
		color: 'black',
		cursor: 'pointer',
	},
	card: {
		paddingLeft: useTheme().spacing(2.5),
		paddingRight: useTheme().spacing(2.5),
	},
	box: {
		minWidth: 800,
	},
	tableHeading: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: 'auto',
	},
	titleContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: '8px',
	},
	actionReset: {
		alignItems: 'center',
		color: useTheme().palette.primary.main,
		display: 'inline-flex',
		justifyContent: 'center',
		marginRight: useTheme().spacing(2),
	},
	actionEdit: {
		alignItems: 'center',
		display: 'inline-flex',
		justifyContent: 'center',
		marginRight: useTheme().spacing(2),
		color: useTheme().palette.primary.main,
	},
	actionDelete: {
		alignItems: 'center',
		display: 'inline-flex',
		justifyContent: 'center',
		marginRight: useTheme().spacing(2),
		color: useTheme().palette.error.main,
	},
	link: {
		textDecoration: 'none',
	},
	customTableField: {
		width: '15%',
	},
	searchBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		position: 'relative',
		maxWidth: '36rem',
	},
	InputContainer: {
		width: '60%',
		height: 40,
		backgroundColor: 'rgba(59, 60, 152, 0.05)',
		paddingLeft: '3rem',
		borderTopRightRadius: 9999,
		borderBottomRightRadius: 9999,
		outline: '2px solid transparent',
		outlineOffset: 2,
		cursor: 'pointer',
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		border: 'none',
		marginTop: '10px',
	},
	submitButtonClass: {
		border: 'none',
		zIndex: 10,
		backgroundColor: 'transparent',
		marginTop: '8px',
		cursor: 'pointer',
		padding: 0,
		// marginLeft: '-1.25rem',
	},
	customSearchBtnClass: {
		marginLeft: '-1.25rem',
	},
	searchBarButtonContainer: {
		display: 'flex',
		gap: 0,
		alignItems: 'center',
	},
	cancelButtonClass: {
		marginLeft: '-2.5rem',
		border: 'none',
		zIndex: 10,
		backgroundColor: 'transparent',
		marginTop: '8px',
		cursor: 'pointer',
		padding: 0,
	},
	searchBarContainer: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
	},
	searchIconClass: {
		border: '1px solid ',
		borderColor: '#bdb9b9',
		borderRadius: 20,
	},
	importuttonClass: {
		height: 36.5,
	},
	titleText: {
		fontSize: '1.5rem',
	},
	sortingLabel: {
		width: '100%',
	},
	[useTheme().breakpoints.down('md')]: {
		titleContainer: {
			justifyContent: 'space-between',
		},
		tableHeading: {
			display: 'flex',
			width: 'auto',
			flexDirection: 'column',
			alignItems: 'baseline',
		},
		InputContainer: {
			width: 'auto',
			// paddingLeft: '0.5rem',
		},
	},
	[useTheme().breakpoints.up('sm')]: {
		searchBar: {
			flexDirection: 'column',
			gap: '1rem',
		},
		InputContainer: {
			borderRadius: 9999,
		},
	},
}));

export default styles;
